/*=========================================================================================
  File Name: module-resource-mutations.js
  Description: Resource Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import defaultState from './module-resource-state';

export default {
	updateResources(state, res) {
		state.Resources.removeAll();
		state.Resources.append(res.Data);
	},
	updateOrders(state, res) {
		state.Orders.removeAll();
		state.Orders.append(res.Data);
	},
	updateUnpaidOrders(state, res) {
		state.UnpaidOrders.removeAll();
		state.UnpaidOrders.append(res);
		state.IsGetUnpaid = true;
	}
};
